<template>
  <div id="math-drill" class="content">
    <router-link class="path mb-1" :to="'/' + pathLink" >&larr;&nbsp;{{ pathText }}</router-link>
    <h4 v-if="isReady">{{ myDrill.title }}&nbsp;&nbsp;<sup><Badges :drill="drill" :key="refreshBadges"/></sup></h4>
    <b-row>
      <b-col cols="12" lg="8">
        <div :class="background" class="p-4" style="min-height: 500px">
          <component v-if="isReady"
            :is="drillComponent"
            :myDrill="myDrill"
            :key="refreshDrill"
            @completed="drillCompleted">
          </component>
          <div class="text-center" v-if="isDone && !isSaved">
            <b-button variant="info" class="mb-2" size="md" @click="recordScore">Record my score</b-button>
            <b-button variant="outline-secondary" class="mb-2" size="md" @click="playAgain">Play again!</b-button>
            <b-button variant="outline-secondary" class="mb-2" size="md" :to="'/' + pathLink" >Try other drills</b-button>
            <br><br>
            <small>
              Once you record the score, score badges will appear next to the drill name.
              They show your latest and average scores including
              the total number of times you've taken this drill.
              See the details <router-link to="/home">here</router-link>.
            </small>
          </div>
          <div class="text-center" v-if="isDone && isSaved">
            <span style="font-size: 1.5em;">Your score is recorded. Great job!</span><br><br>
            <b-button variant="info" class="mb-2" size="md" @click="playAgain">Play again!</b-button>
            <b-button variant="outline-secondary" class="mb-2" size="md" :to="'/' + pathLink" >Try other drills</b-button>
          </div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="d-none d-lg-block text-left">
          <!-- ad block -->
          <Adsense
            :key="drill + 'ad1'"
            ins-class="adsbygoogle"
            ins-style="display:block"
            data-ad-client="ca-pub-2952722942479594"
            data-ad-slot="5793802217"
            data-ad-format="auto"
            :data-full-width-responsive="true">
          </Adsense>
          <br>
          <!-- ad block -->
          <Adsense
            :key="drill + 'ad2'"
            ins-class="adsbygoogle"
            ins-style="display:block"
            data-ad-client="ca-pub-2952722942479594"
            data-ad-slot="5793802217"
            data-ad-format="auto"
            :data-full-width-responsive="true">
          </Adsense>
        </div>
      </b-col>
    </b-row>
    <br />
  </div>
</template>
<script>
import '@/common/css/patterns.css'
import * as Store from '@/common/js/store.js'
import * as uiUtil from '@/common/js/uiutil.js'
import { backgrounds } from '@/common/js/constants.js'

import Badges from '@/common/Badges.vue'

export default {
  name: 'MathDrill',
  props: ['drill'],
  components: {
    Badges
  },
  data () {
    return {
      myDrill: null,
      score: 0, // received from the child component through an emit event
      isReady: false, // true if the drill is ready to take
      isDone: false, // true if the drill is completed
      isSaved: false, // true if the score is saved
      refreshDrill: 0, // used to refresh an operation component
      refreshBadges: 0 // used to refresh Badges component
    }
  },
  created: function () {
    var tmpDrill = this.drill.split('-')
    var override = (tmpDrill.length === 2)

    if (override) this.drill = tmpDrill[0]
    // console.log('drill id = ' + this.drill)

    var drillFile = this.drill.substring(0, 3) + '/' + this.drill + '.js'
    import('@/math/drills/' + drillFile).then(response => {
      this.myDrill = response.default
      if (override) this.myDrill.config.nProblems = parseInt(tmpDrill[1])

      this.isReady = true
    })
  },
  computed: {
    drillComponent: function () {
      var name = this.myDrill.operation
      name = name.split('-').map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join('')
      return () => import(`@/math/operations/${name}.vue`)
    },
    pathLink: function () {
      var items = this.$route.path.split('/')

      // Short URL: host/arithmetic/addptux
      // Depreciated URL: host/arithmetic/addptux/add-3-digit-to-2-digit-numbers-mentally
      if (items.length === 3 || items.length === 4) return items[1]

      // Normal URL: host/arithmetic/addptux/addition/add-3-digit-to-2-digit-numbers-mentally
      return items[1] + '#' + items[3]
    },
    pathText: function () {
      var items = this.$route.path.split('/')

      // Short URL: host/arithmetic/addptux
      // Depreciated URL: host/arithmetic/addptux/add-3-digit-to-2-digit-numbers-mentally
      var topic = uiUtil.capitalizeFirstChars(items[1].replace(/-/g, ' ')).replace('Pre Algebra', 'Pre-algebra')
      if (items.length === 3 || items.length === 4) return topic

      // Normal URL: host/arithmetic/addptux/addition/add-3-digit-to-2-digit-numbers-mentally
      var section = uiUtil.capitalizeFirstChars(items[3].replace(/-/g, ' ')).replace(' And ', ' and ')
      return topic + ' / ' + section
    },
    background: function () {
      return backgrounds[Math.floor(Math.random() * backgrounds.length)]
    }
  },
  methods: {
    drillCompleted (score) {
      this.score = score
      this.isDone = true
    },
    playAgain: function () {
      this.score = 0
      this.isDone = false
      this.isSaved = false

      // This forces Vue to re-render a component.
      // See mmichaelnthiessen.com/force-re-render
      this.refreshDrill += 1
    },
    recordScore: function () {
      var currentuser = Store.userRecord.current()
      Store.scoreRecord.update(currentuser.id, this.drill, this.score)

      // This forces Vue to re-render a component.
      // See mmichaelnthiessen.com/force-re-render
      this.refreshBadges += 1

      this.isSaved = true
      // this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/math/MathDrill.vue